export default "__VITE_ASSET__C2JhMd3l__"